module.exports = __webpack_public_path__ + "static/7gde-25a61488a49282b1b0ddb8746857c357.gif";